import React from 'react';

import productWithPackagingBox from '../../../main/assets/images/lapRf/immersionrc-lap-rf-packaging-box.webp';

export const NoTranspodersNeeded = () => {
  return (
    <section className="laprf-transponders">
      <div className="laprf-transponders-text">
        <h2 className="laprf-transponders-title">
          <span className="laprf-transponders-connected-title">
            No Transponders
          </span>
          <span> Required</span>
        </h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="2"
          viewBox="0 0 100 2"
          preserveAspectRatio="none"
          className="laprf-transponders-line"
        >
          <path d="M0 0.693359H470" stroke="url(#paint0_linear_900_2853)" />
          <defs>
            <linearGradient
              id="paint0_linear_900_2853"
              x1="0"
              y1="1.19336"
              x2="100"
              y2="1.19336"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.509" stopColor="#FF2238" />
              <stop offset="1" stopColor="#FF2238" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <p className="laprf-transponders-description">
          Skip the hassle of RFID or infrared. LapRF detects drones via 5.8GHz
          video transmitters - just place it at the gate and start racing.
        </p>
      </div>
      <img
        src={productWithPackagingBox}
        alt="The Item Displayed with its Packaging Box"
        className="laprf-transponders-product"
      />
    </section>
  );
};
